import React, { useEffect, useState } from "react";
import "./About.scss";
import about1 from "../../Assets/images/About/about-01.png";
import about2 from "../../Assets/images/About/about-02-mov.png";
import about3 from "../../Assets/images/About/about-02.png";
import arrow from "../../Assets/images/About/arrow.png";
import { ArrowRightOutlined } from "@ant-design/icons";
import TextUnderline from "../../Component/TextUnderline/TextUnderline";
import useWindowSize from "../../Utils/useWindowSize/useWindowSize";
import { useTranslation } from "react-i18next";

import ScrollToTop from "../../Component/ScrollToTop/ScrollToTop";
import { useHistory } from "react-router-dom";

type Props = {};

const textUnderline1 = "XUXU Profile";
const textUnderline21 = "This is XUXU,";
const textUnderline22 = "Executive Creative Director,";
const textUnderline23 = "artist, and designer";
const textUnderline24 = "based in Osaka,";
const textUnderline25 = "Japan.";

const textUnderline41 = "I consult &";
const textUnderline42 = [
  {
    text: "design",
  },
  {
    text: "product :",
  },
];

const About = (props: Props) => {
  const { width, height } = useWindowSize();
  const history = useHistory();
  const { t } = useTranslation();

  const textUnderline3 = t('conferenceEvents');
  const [styleHeading, setStyleHeading] = useState({
    fontSize: `54px`,
    fontFamily: "$montserrat",
    marginRight: "25px",
    fontWeight: "600",
    lineHeight: "1.1",
    color: "#040404",
  });
  const [borderHeighHeading, setBorderHeading] = useState(5);

  const [styleInfo1, setStyleInfo1] = useState<any>({
    fontSize: `54px`,
    fontFamily: "$montserrat",
    marginRight: "20px",
    fontWeight: "600",
    marginBottom: "10px",
    color: "#040404",
  });
  const [borderHeightInfo1, setBorderHeightInfo1] = useState<number>(5);
  const [styleInfo2, setStyleInfo2] = useState<any>({
    fontSize: `24px`,
    fontFamily: "$montserrat",
    marginRight: "20px",
    fontWeight: "400",
    marginBottom: "20px",
    lineHeight: "0.5",
  });
  const [borderHeightInfo2, setBorderHeightInfo2] = useState<number>(0.5);
  const [styleInfo3, setStyleInfo3] = useState<any>({
    fontSize: `54px`,
    fontFamily: "$montserrat",
    marginRight: "20px",
    fontWeight: "600",
    marginBottom: "20px",
    // lineHeight: '0.5',
    color: "#040404",
    cursor: "pointer",
  });
  const [borderHeightInfo3, setBorderHeightInfo3] = useState<number>(5);
  useEffect(() => {
    if (width > 1279) {
      setStyleHeading({
        fontSize: `54px`,
        fontFamily: "$montserrat",
        marginRight: "25px",
        fontWeight: "600",
        lineHeight: "1.1",
        color: "#040404",
      });
      setBorderHeading(5);
      setStyleInfo1({
        fontSize: `54px`,
        fontFamily: "$montserrat",
        marginRight: "20px",
        fontWeight: "600",
        marginBottom: "10px",
        color: "#040404",
      });
      setBorderHeightInfo1(5);
      setStyleInfo2({
        fontSize: `24px`,
        fontFamily: "$montserrat",
        marginRight: "20px",
        fontWeight: "400",
        marginBottom: "20px",
        lineHeight: "0.5",
      });
      setBorderHeightInfo2(0.5);
      setStyleInfo3({
        fontSize: `54px`,
        fontFamily: "$montserrat",
        marginRight: "20px",
        fontWeight: "600",
        marginBottom: "20px",
        // lineHeight: '0.5',
        color: "#040404",
        cursor: "pointer",
      });
      setBorderHeightInfo3(5);
    }
    if (width <= 1279 && width > 768) {
      setStyleInfo1({
        ...styleInfo1,
        fontSize: "24px",
        fontWeight: "600",
        marginBottom: "15px",
        lineHeight: "1",
        color: "#040404",
      });
      setBorderHeightInfo1(3);
      setStyleInfo2({
        ...styleInfo2,
        fontSize: "16px",
        marginBottom: "15px",
      });

      setStyleInfo3({
        ...styleInfo3,
        fontSize: "24px",
        marginRight: "10px",
        marginBottom: "10px",
        lineHeight: "1",
        cursor: "pointer",
      });
      setBorderHeightInfo3(3);
    } else if (width <= 768 && width > 480) {
      setStyleInfo1({
        ...styleInfo1,
        fontSize: "16px",
        marginRight: "10px",
        marginBottom: "10px",
        color: "#040404",
        lineHeight: "1",
      });
      setBorderHeightInfo1(2);
      setStyleHeading({
        ...styleHeading,
        fontSize: `30px`,
        marginRight: "15px",
        lineHeight: "1.2",
      });
      setBorderHeading(3);

      setStyleInfo2({
        ...styleInfo2,
        fontSize: "16px",
      });
      setStyleInfo3({
        ...styleInfo3,
        fontSize: "16px",
        marginRight: "10px",
        marginBottom: "10px",
        lineHeight: "1",
        cursor: "pointer",
      });
      setBorderHeightInfo3(2);
    } else if (width <= 480 && width > 320) {
      setStyleInfo1({
        ...styleInfo1,
        fontSize: "24px",
        fontWeight: "600",
        marginRight: "10px",
        marginBottom: "15px",
        lineHeight: "1",
      });
      setBorderHeightInfo1(3);

      setStyleHeading({
        ...styleHeading,
        fontSize: `24px`,
        marginRight: "10px",
        lineHeight: "1.2",
      });
      setBorderHeading(3);
      setStyleInfo2({
        ...styleInfo2,
        fontSize: "16px",
        marginBottom: "10px",
      });

      setStyleInfo3({
        ...styleInfo3,
        fontSize: "24px",
        fontWeight: "600",
        marginBottom: "15px",
        marginRight: "10px",
        lineHeight: "1",
        cursor: "pointer",
      });
      setBorderHeightInfo3(3);
    } else if (width <= 320) {
      setStyleInfo2({
        ...styleInfo2,
        fontSize: "14px",
        marginBottom: "10px",
      });
    }
  }, [width]);
  return (
    <>
      <ScrollToTop />
      <div className="about-container">
        <div className="about-heading">
          {textUnderline1.split(" ").map((item, index) => (
            <TextUnderline
              bottom={0}
              key={index}
              style={styleHeading}
              borderheight={borderHeighHeading}
            >
              {item}
            </TextUnderline>
          ))}
        </div>
        <div className="about-banner1">
          <img src={about1} alt="" />
        </div>
        <div className="about-info1">
          <div className="about-info1-left">
            <div>
              {textUnderline21.split(" ").map((item, index) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfo1}
                  borderheight={borderHeightInfo1}
                >
                  {item}
                </TextUnderline>
              ))}
            </div>
            <div>
              {textUnderline22.split(" ").map((item, index) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfo1}
                  borderheight={borderHeightInfo1}
                >
                  {item}
                </TextUnderline>
              ))}
            </div>
            <div>
              {textUnderline23.split(" ").map((item, index) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfo1}
                  borderheight={borderHeightInfo1}
                >
                  {item}
                </TextUnderline>
              ))}
            </div>
            <div>
              {textUnderline24.split(" ").map((item, index) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfo1}
                  borderheight={borderHeightInfo1}
                >
                  {item}
                </TextUnderline>
              ))}
            </div>
            <div>
              {textUnderline25.split(" ").map((item, index) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfo1}
                  borderheight={borderHeightInfo1}
                >
                  {item}
                </TextUnderline>
              ))}
            </div>
          </div>
          <div className="about-info1-right">
            <div className="about-info1-text1">
              <p>
                {t('aboutText1')}
              </p>
            </div>

            <div className="about-info1-text2">
              <p>
                {t('aboutText2')}
              </p>
            </div>
          </div>
        </div>
        <div className="about-video">
          <img src={about2} alt="" />
        </div>
        <div className="about-info2">
          <div className="about-info2-left">
            <div className="about-info2-left-text">
              <p>
                {t('aboutTextLeft')}
              </p>
            </div>

            <div>
              {textUnderline3.split(".").map((item, index) => (
                <div key={index} className="line-info-2">
                  <TextUnderline
                    bottom={0}
                    style={styleInfo2}
                    borderheight={borderHeightInfo2}
                  >
                    {item}.
                  </TextUnderline>
                  <br />
                </div>
              ))}
            </div>
          </div>
          <div className="about-info2-right">
            <div className="about-info2-right-text">
              {t('aboutTextRight1')}
            </div>
            <div className="about-info2-right-text">
              {t('aboutTextRight2')}
            </div>
            <div className="about-info2-right-text">
              {t('aboutTextRight3')}
            </div>
            <div className="about-info2-right-text">
              {t('aboutTextRight4')}
            </div>
          </div>
        </div>
        <div className="about-banner2">
          <img src={about3} alt="" />
        </div>
        <div className="about-info3">
          <div className="about-info3-left">
            <div>
              {textUnderline41.split(" ").map((item, index) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  {item}
                </TextUnderline>
              ))}
            </div>
            <div>
              {textUnderline42.map((item, index) => (
                <TextUnderline
                  bottom={0}
                  key={index}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  {item.text}
                </TextUnderline>
              ))}
            </div>
          </div>
          <div className="about-info3-right">
            <div className="about-info3-right-text">
              <div
                className="line1"
                onClick={() =>
                  history.push({ pathname: "/works", search: "fineart" })
                }
              >
                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  <img className="img-arrow" src={arrow} alt="" />
                </TextUnderline>

                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  Fine art :
                </TextUnderline>
              </div>
              <div className="line2">
                <p className="">
                  {t('workDescriptions.fineArt')}
                </p>
              </div>
            </div>
            <div className="about-info3-right-text">
              <div
                className="line1"
                onClick={() =>
                  history.push({ pathname: "/works", search: "graphicdesign" })
                }
              >
                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  {/* <ArrowRightOutlined /> */}
                  <img className="img-arrow" src={arrow} alt="" />
                </TextUnderline>

                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  Graphic design :
                </TextUnderline>
              </div>
              <div className="line2">
                <p className="">
                  {t('workDescriptions.graphicDesign')}
                </p>
              </div>
            </div>
            <div className="about-info3-right-text">
              <div
                className="line1"
                onClick={() =>
                  history.push({ pathname: "/works", search: "illustration" })
                }
              >
                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  <img className="img-arrow" src={arrow} alt="" />
                </TextUnderline>

                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  Illustration :
                </TextUnderline>
              </div>
              <div className="line2">
                <p className="">
                  {t('workDescriptions.illustration')}
                </p>
              </div>
            </div>
            <div className="about-info3-right-text">
              <div
                className="line1"
                onClick={() =>
                  history.push({ pathname: "/works", search: "advertising" })
                }
              >
                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  <img className="img-arrow" src={arrow} alt="" />
                </TextUnderline>

                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  Advertising :
                </TextUnderline>
              </div>
              <div className="line2">
                <p className="">
                  {t('workDescriptions.advertising')}
                </p>
              </div>
            </div>
            <div className="about-info3-right-text">
              <div
                className="line1"
                onClick={() =>
                  history.push({ pathname: "/works", search: "game" })
                }
              >
                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  <img className="img-arrow" src={arrow} alt="" />
                </TextUnderline>

                <TextUnderline
                  bottom={0}
                  style={styleInfo3}
                  borderheight={borderHeightInfo3}
                >
                  Game :
                </TextUnderline>
              </div>
              <div className="line2">
                <p className="">
                  {t('workDescriptions.game')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
